// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.template-item-grid[data-v-2d5833c6] {\n  display: grid;\n  grid-template-columns: 3% 84% 13%;\n}\n", ""]);
// Exports
module.exports = exports;
